/**
 * GoToTop
 */

import Config from './Config';
import Util from './Util';

let __instance: GoToTop = null;

class GoToTop {

	private name: string;

	private parent: string;

	constructor() {
		if ( !__instance ) {
			this.name = 'co-btn-top';
			this.parent = 'body';

			// @TODO CNB이벤트와 충돌
			this.addEvent();

			__instance = this;
		}

		return __instance;
	}

	public show() {
		jQuery( this.parent ).append( this.template() );
	}

	private template() {
		return `<a href="#" class="co-btn ${this.name}"><i class="fe-icon-top"></i></a>`;
	}

	private fulfill() {
		( jQuery( window ).scrollTop() === 0 ) ?
			jQuery( `.${this.name}` ).hide() :
			jQuery( `.${this.name}` ).show();
	}

	private addEvent() {
		jQuery( 'body' ).on( 'click', `.${this.name}`, ( evt ) => {
			evt.preventDefault();
			jQuery( window ).scrollTop( 0 );
		});

		// // @TODO remove
		// jQuery( window ).on( 'scroll', ( scrollEvt ) => {
		// 	this.fulfill();
		// });
	}
}

export default new GoToTop();
